"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/SMSResubscribeModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reacthookform = require('react-hook-form');





var _smsPreference = require('shared/validation/smsPreference');

var _consent = require('shared/services/consent');



var _smsDelivery = require('shared/services/smsDelivery');

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _ConsentHowFields = require('web/components/ConsentHowFields'); var _ConsentHowFields2 = _interopRequireDefault(_ConsentHowFields);

// How and when the patient asked again ("YYYY-MM-DD").




















 const SMS_RESUBSCRIBE_TITLE = 'Resubscribe to SMS'; exports.SMS_RESUBSCRIBE_TITLE = SMS_RESUBSCRIBE_TITLE
 const SMS_RESUBSCRIBE_CONSENT_COPY =
  'Only continue if the patient has explicitly asked to receive text messages from your organization again.'; exports.SMS_RESUBSCRIBE_CONSENT_COPY = SMS_RESUBSCRIBE_CONSENT_COPY
 const SMS_RESUBSCRIBE_CONSENT_CHECKBOX_LABEL =
  'The patient asked to receive texts from us again.'; exports.SMS_RESUBSCRIBE_CONSENT_CHECKBOX_LABEL = SMS_RESUBSCRIBE_CONSENT_CHECKBOX_LABEL
const SMS_ASKED_AGAIN_TITLE = 'Record that they asked again'

const DEFAULT_VALUES = { reason: '' }

// Clears an opt-out a staff member recorded (admins only). The admin ticks
// the consent box and gives the reason that goes in the deliverability
// history. It never lifts a block Twilio enforces: a patient's own STOP or a
// carrier block clears only when the patient texts START. In a consent org
// (isAskedAgain) it instead records that a patient who texted STOP asked
// again, with how and when; their block stays until they text START.
const SMSResubscribeModal = ({
  isOpen, patientName, remainingCopy, isAskedAgain = false, onClose, onConfirm,
}) => {
  const { control, formState, handleSubmit, reset } = _reacthookform.useForm({
    mode: 'onChange',
    resolver: _smsPreference.smsPreferenceReasonResolver,
    defaultValues: DEFAULT_VALUES,
  })
  const { isValid, isSubmitting, errors } = formState
  const [hasConsent, setHasConsent] = _react.useState.call(void 0, false)
  const [how, setHow] = _react.useState(null)
  const [askedOn, setAskedOn] = _react.useState.call(void 0, '')

  _react.useEffect.call(void 0, () => {
    if (!isOpen) return
    reset(DEFAULT_VALUES)
    setHasConsent(false)
    setHow(null)
    setAskedOn(_consent.todayConsentDate.call(void 0, ))
  }, [isOpen, reset])

  const submit = _react.useCallback.call(void 0, 
    ({ reason }) => isAskedAgain && how
      ? onConfirm(reason.trim(), { how, askedOn })
      : onConfirm(reason.trim()),
    [onConfirm, isAskedAgain, how, askedOn],
  )
  const hasAskedAgainFields = !isAskedAgain || (!!how && !!askedOn)
  const name = patientName || 'this patient'
  const onConsentChange = _react.useCallback.call(void 0, 
    (e) => setHasConsent(e.target.checked),
    [],
  )

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      onClose: onClose,
      title: isAskedAgain ? SMS_ASKED_AGAIN_TITLE : exports.SMS_RESUBSCRIBE_TITLE,
      className: "sms-resubscribe-modal",
      size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}

      , _react2.default.createElement(_Modal.ModalSubtitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}, "Did "
         ,  name , " ask to receive texts again?"
      )
      ,  isAskedAgain && (
        _react2.default.createElement(_Modal.ModalDesc, { className: "sms-resubscribe-modal--desc sms-resubscribe-modal--block" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
          ,  name , " texted STOP, so their phone stays blocked until they text START. Carriers don't let anyone else lift it. Record how they asked, then ask them to text START."

        )
      )
      , _react2.default.createElement(_Modal.ModalDesc, { className: "sms-resubscribe-modal--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}
        ,  exports.SMS_RESUBSCRIBE_CONSENT_COPY 
      )
      ,  !!remainingCopy && (
        _react2.default.createElement(_Modal.ModalDesc, { className: "sms-resubscribe-modal--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}
          ,  remainingCopy 
        )
      )
      ,  isAskedAgain && (
        _react2.default.createElement(_ConsentHowFields2.default, {
          howLabel: "How did they ask?"   ,
          how: how,
          onHowChange: setHow,
          date: askedOn,
          onDateChange: setAskedOn, __self: this, __source: {fileName: _jsxFileName, lineNumber: 116}}
        )
      )
      , _react2.default.createElement('label', { className: "sms-resubscribe-modal--consent", __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}
        , _react2.default.createElement('input', {
          type: "checkbox",
          checked: hasConsent,
          onChange: onConsentChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}
        )
        , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 130}},  exports.SMS_RESUBSCRIBE_CONSENT_CHECKBOX_LABEL )
      )
      , _react2.default.createElement(_Form.InputSectionWrapper, {
        title: _smsDelivery.SMS_PREFERENCE_REASON_LABEL,
        errorMessage: _optionalChain([errors, 'access', _ => _.reason, 'optionalAccess', _2 => _2.message]),
        className: "sms-preference-reason", __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}

        , _react2.default.createElement(_Form.SimpleTextAreaController, {
          name: "reason",
          control: control,
          'aria-label': _smsDelivery.SMS_PREFERENCE_REASON_LABEL,
          placeholder: _smsDelivery.SMS_RESUBSCRIBE_REASON_PLACEHOLDER,
          maxLength: _smsPreference.SMS_PREFERENCE_REASON_MAX_LENGTH, __self: this, __source: {fileName: _jsxFileName, lineNumber: 137}}
        )
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: isAskedAgain ? 'Record' : 'Yes, resubscribe',
        secondaryBtnLabel: "Cancel",
        isPrimaryLoading: isSubmitting,
        isPrimaryEnabled: hasConsent && hasAskedAgainFields && isValid && !isSubmitting,
        onPrimaryBtnClick: handleSubmit(submit),
        onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}}
      )
    )
  )
}

exports. default = SMSResubscribeModal
